import {EntityTypeValue} from '../component/entity-type-component.domain';
import {TitleSelectionValue} from '../component/title-selection-component.domain';
import {GenderValue} from '../component/gender-component.domain';
import {Moment} from 'moment';
import {Address2ComponentValue} from '../component/address2-component.domain';
import { PropertyOwnerWithAddressValue } from '../component/property-owner-with-address-component.domain'
import {YesNoValue} from '../component/yes-no-component.domain';
import { PersonalAssetsValue } from '../component/personal-assets-component.domain';
import { PersonalLiabilitiesValue } from '../component/personal-liabilities-component.domain';
import {BusinessNumberSearchValue} from './business-number-search-component.domain';
import {CountryOfCitizenshipValue} from './individual-form-component.domain';
import {IdentificationComponentValue} from './identification-component.domain';
import {UploadFileValue} from './file-upload-component.domain';
import {ExistingPersonRef} from '../../utils/individual-identity';

export type EntityTrustee = {
  kind: 'Trustee',
  type: 'Entity',
  organisation: Exclude<BusinessNumberSearchValue, null>,
  organisationType: Exclude<EntityTypeValue, null>,
  acn: string,
  abn: string,
  manualEntry: boolean,
  // businessName: string,
  // stepacn: string
};
export type IndividualTrustee = {
  kind: 'Trustee',
  type: 'Individual',
  // The saved individual a reopened draft prefilled this from; unset for a person typed in.
  guid?: string,
  title: TitleSelectionValue,
  firstName: string,
  lastName: string,
  middleName: string,
  // no longer collected by the unified individual-form; kept optional for historical values
  gender?: GenderValue,
  dob: Moment,
  hasAlias?: boolean,
  aliasNames?: string | null,
  countryOfCitizenship?: CountryOfCitizenshipValue,
  identification?: IdentificationComponentValue,
  idDocument?: UploadFileValue,
  residentialAddress: Address2ComponentValue,
  propertyOwner: PropertyOwnerWithAddressValue,
  email: string,
  mobileNumber: string,
  // no longer collected per person; guarantor selection happens on the KYB Key People screen
  guarantor?: YesNoValue,
  personalAssets: PersonalAssetsValue,
  personalLiabilities: PersonalLiabilitiesValue,
};
export type TrusteeValue = (IndividualTrustee | EntityTrustee)[] | null;

/** Popup capture of name + dob for a KYB individual trustee. Pre-filled values when editing. */
export interface KybIndividualTrusteeDialogData {
  /** Overrides the heading, so the same name/DOB form can name whichever party it is collecting. */
  title?: string;
  firstName: string | null;
  middleName: string | null;
  lastName: string | null;
  dob: Moment | null;
  /**
   * People already on the application, which the dialog refuses to add a second time. Left unset by
   * the Add Partner / Add Trustee dialogs: the same human can be a director of the applicant and a
   * trustee of a guarantor trust, so a party declaration is not a duplicate.
   */
  existingPeople?: ExistingPersonRef[];
}

export interface KybIndividualTrusteeDialogResult {
  firstName: string;
  middleName: string | null;
  lastName: string;
  dob: Moment;
}
